<template>
  <div class="mobile-class-selector">
    <ClassSelector device-type="mobile" />
  </div>
</template>

<script>
import ClassSelector from '@/components/shared/ClassSelector.vue';

export default {
  name: 'MobileClassSelector',
  components: {
    ClassSelector
  },
  mounted() {
    // 设置移动端视图类
    document.body.classList.add('mobile-view');
  },
  beforeDestroy() {
    // 移除移动端视图类
    document.body.classList.remove('mobile-view');
  }
}
</script>

<style scoped>
.mobile-class-selector {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* 移动端全局样式 */
.mobile-view {
  font-size: 16px; /* 防止iOS缩放 */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

/* 优化移动端触摸体验 */
.mobile-view * {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.mobile-view input,
.mobile-view textarea {
  -webkit-user-select: text;
  user-select: text;
}
</style>